const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const WEEKDAYS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

export function toUTCDate(date) {
    return new Date(Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ));
}


function toUTCDateSmall(val) {
  const [y, m, d] = val.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

export function createFormatters(xKey, windowSize = Infinity) {
  const tickFormatter = (val) => {
    if (xKey === "month"){
      const [, m] = val.split("-").map(Number);
      return MONTHS[m - 1];
    } else if (xKey === "date") {
      const date = toUTCDateSmall(val);
      if (windowSize === 7) {
        return WEEKDAYS[date.getUTCDay()];
      }
      const month = MONTHS[date.getUTCMonth()];
      const day = date.getUTCDate();
      return `${month} ${day}`;
    } else { return undefined; }
  }

  const labelFormatter = (val) => {
    if (xKey === "month") {
      const [y, m] = val.split("-").map(Number);
      return `${MONTHS[m - 1]} ${y}`;
    } else if (xKey === "date") {
      const date = toUTCDateSmall(val);
      const month = MONTHS[date.getUTCMonth()];
      const day = date.getUTCDate();
      const year = date.getUTCFullYear();
      if (windowSize === 7) {
        const wd = WEEKDAYS[date.getUTCDay()];
        return `${wd}, ${month} ${day}, ${year}`;
      }
      return `${month} ${day}, ${year}`;
    } else { return undefined; }
  }

  return { tickFormatter, labelFormatter };
}

